<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutColumnCenterStart">
  <div class="move-container">
    <div>
      <mat-icon class="mdi-24px sp-icon" fontIcon="mdi-account-group"></mat-icon>
    </div>
    <mat-form-field class="search-field">
      <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event.target.value)"
        placeholder="Search Groups" />
    </mat-form-field>
    <div style="width: 24px;">
      <button mat-icon-button style="outline: none;" title="Clear Search" (click)="clearFilter()"
        [disabled]="!filterString">
        <mat-icon class="mdi-18px" fontIcon="mdi-close-circle-outline"></mat-icon>
      </button>
    </div>
  </div>
  <div class="table-container">
  <table mat-table [dataSource]="dataSource$ | async" matSort multiTemplateDataRows>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <div class="button-cell">
          <button mat-icon-button matTooltip="Add New Group" (click)="createGroup()" [disabled]="!canEdit">
            <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
          </button>
          <button mat-icon-button class="primary-color" disabled
              matTooltip="Users can be added to Groups here or, if enabled in your environment, can be matched to Group Names from the token of the Identity Provider in use."
              matTooltipShowDelay="0">
            <mat-icon class="mdi-24px" fontIcon="mdi-information"></mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button matTooltip="Delete {{ element.name }}"
          (click)="$event.stopPropagation(); deleteGroup(element)" [disabled]="!canEdit">
          <mat-icon class="mdi-24px" color="primary" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        <button mat-icon-button matTooltip="Rename"
          (click)="$event.stopPropagation(); updateGroup(element)" [disabled]="!canEdit">
          <mat-icon class="mdi-24px" color="primary" fontIcon="mdi-square-edit-outline"></mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Group Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div [@detailExpand]="element.id === expandedGroupId ? 'expanded' : 'collapsed'"
          (click)="$event.stopPropagation()">
          @if (element.id === expandedGroupId) {
            <app-admin-groups-detail [groupId]="element.id" [canEdit]="canEdit"></app-admin-groups-detail>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"
      (click)="toggleExpand(row.id)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
  </div>
</div>
